import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IYearlevel_map } from "../../../Pages/Yearlevel_map/IYearlevel_map";

export const ListYearlevel_mapSlice = createSlice({
  name: "ListYearlevel_mapSlice",
  initialState: {} as IReduxState<IYearlevel_map[]>,
  reducers: {
    listYearlevel_map: (state) => {
      state.isLoading = true;
    },
    successlistYearlevel_map: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistYearlevel_map: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistYearlevel_map,
  listYearlevel_map,
  successlistYearlevel_map,
} = ListYearlevel_mapSlice.actions;

export default ListYearlevel_mapSlice.reducer;
